import { I18n } from '@calendly/i18n';
import { ChatBubbleSquareIcon, QuestionCircleIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { BodyText, HeadlineText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c15770f3";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const footerCss = "fpv92ff";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
const styledLinkCss = "sr3vkc2";
const StyledLink = forwardRef((props, ref) => <Link ref={ref} {...props} className={classNames(styledLinkCss, props.className)} />);
const nudgedHelpIconCss = "n1bhyutt";
const NudgedHelpIcon = forwardRef((props, ref) => <QuestionCircleIcon ref={ref} {...props} className={classNames(nudgedHelpIconCss, props.className)} />);
const helpCenterLinkCss = "h13bxfm6";
const HelpCenterLink = forwardRef((props, ref) => {
  const href = '/help';
  const target = '_blank';
  const rel = 'noopener noreferrer';
  const underline = false;
  return <StyledLink ref={ref} {...props} href={href} target={target} rel={rel} underline={underline} className={classNames(helpCenterLinkCss, props.className)}>
      <NudgedHelpIcon />
      {I18n.t('publisher.meeting_intelligence.details.status_footer.help_center_link')}
    </StyledLink>;
});
const supportChatLinkCss = "s1bpwtb2";
const SupportChatLink = forwardRef((props, ref) => {
  const href = 'https://calendly.com/help/support';
  const target = '_blank';
  const rel = 'noopener noreferrer';
  const underline = false;
  return <StyledLink ref={ref} {...props} href={href} target={target} rel={rel} underline={underline} className={classNames(supportChatLinkCss, props.className)}>
      <ChatBubbleSquareIcon />
      {I18n.t('publisher.meeting_intelligence.details.status_footer.chat_with_support_link')}
    </StyledLink>;
});
export const BaseState = ({
  heading,
  description,
  ctaButton,
  imgSrc,
  imgAltText,
  isEmptyFilteredList = false
}) => <Container data-testid="base-state">
    {imgSrc && <img src={imgSrc} alt={imgAltText || ''} />}
    <HeadlineText size="large">{heading}</HeadlineText>
    <BodyText color="muted">{description}</BodyText>
    {ctaButton}
    {!isEmptyFilteredList && <Footer>
        <HelpCenterLink />
        <SupportChatLink />
      </Footer>}
  </Container>;

require("./base_state.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./base_state.js");